module.exports = __webpack_public_path__ + "img/angel-1.df7917f7.jpg";